import { useEffect } from 'react';
import { useField } from 'react-final-form';

import { OrganizationContractType } from '../../../../models/enums/ContractType';
import { DutyOfCareSubscriptionOptions } from '../../../../models/enums/DutyOfCareSubscriptionOptions';
import { getFormGroupPath } from '../../../../utils/getFormGroupPath';

type UseDutyOfCareSubscriptionForm = {
  contractType?: OrganizationContractType;
  name?: string;
};

export const useDutyOfCareSubscriptionForm = ({
  contractType,
  name,
}: UseDutyOfCareSubscriptionForm) => {
  const {
    input: { onChange: autoRenewChange },
  } = useField(
    getFormGroupPath(name, DutyOfCareSubscriptionOptions.AutoRenewal),
  );
  useEffect(() => {
    contractType !== OrganizationContractType.Multiple &&
      autoRenewChange(false);
  }, [autoRenewChange, contractType]);
};
